import { BoxContainer, PrimaryButton, ReactIcons, TopBarProps } from "@kalyzee/kalyzee-ui";

import React, { useState } from "react";

export interface SectionWorkBoxProps {
  style?: React.CSSProperties;
  foldable?: boolean;
  sections: {
    header: React.ReactNode;
    content: React.ReactNode;
  }[];
  onClose?: () => void;
}

export const SectionWorkBox = React.memo(({
  style,
  foldable = true,
  sections,
  onClose,
}: SectionWorkBoxProps) => {
  const [foldedSections, setFoldedSections] = useState<{ [key: number]: boolean }>([]);

  const onUpdateSection = (index: number) => {
    setFoldedSections((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const getSectionHeaderProps = (header: React.ReactNode, index: number): TopBarProps => ({
    left: foldable ? [
      <ReactIcons.ThreeDots
        style={{
          height: "1em",
          transform: foldedSections[index] ? "rotate(0deg)" : "rotate(90deg)",
          transition: "transform 0.2s",
        }}
      />,
    ] : [],
    center: [
      header,
    ],
    right: onClose ? [
      <PrimaryButton onClick={onClose}>
        <ReactIcons.Close style={{ height: "0.8em" }} />
      </PrimaryButton>
    ] : [],
    nativeProps: {
      onClick: foldable ? () => onUpdateSection(index) : undefined,
      style: {
        cursor: foldable ? "pointer" : undefined,
        whiteSpace: "nowrap",
      }
    },
  });

  const renderSections = () => {
    const nodes: React.ReactNode[] = [];

    const renderSectionContent = (content: React.ReactNode, index: number) => {
      return (
        <div
          key={`section-content-${index}`}
          style={{
            display: foldedSections[index] ? "none" : "flex",
            flex: 1,
            minHeight: 0,
          }}
        >
          {content}
        </div>
      );
    };

    const firstSection = sections[0];
    if (firstSection) {
      nodes.push(renderSectionContent(firstSection.content, 0))
    }

    for (let i = 1; i < sections.length; i++) {
      const section = sections[i];
      nodes.push(
        <BoxContainer.Bar
          {...getSectionHeaderProps(section.header, i)}
          key={`section-header-${i}`}
        />
      );
      nodes.push(renderSectionContent(section.content, i));
    }

    return nodes;
  }

  return (
    <BoxContainer
      style={style}
      topBarProps={sections[0] ? getSectionHeaderProps(sections[0].header, 0) : {}}
    >
      {renderSections()}
    </BoxContainer>
  );
});